<template>
	<section v-if="getMessages">
		<!--todas redes sociais  barra superior hidden-->
		<div class='barra-superior direita flex-start'>

			<div class="rede-social esquerda hover-change-color tamanho-aviso text-center active">
				<img src="/imgs/icons/message.svg" class="icon-size">
				<p class="m-1">Chat</p>
				<span :class="[getTotalChatQueue > 0 ? 'alert-message-out': 'alert-message-in']">
					<span :class="[getTotalChatQueue > 0 ? 'alert-message': 'alert-message-fine']"
					>{{ getTotalChatQueue }}</span>
				</span>
			</div>
			<button id="btnNovoChamado" class="btn" v-on:click="showForm()" :class="this.toggleForm ? 'buttonOn' : 'buttonOff'">Novo Chamado</button>
			<h3 id="title" class="text-center">Atendimento</h3>

			<div> &nbsp; </div>
		</div>
		<div class="body">
			<TodasMenssagensChat class="todasMensagens"></TodasMenssagensChat>
			<chat-mensagem class="chatMensagem"></chat-mensagem>
		<div v-show="this.toggleForm" style="position: absolute; margin-left: 800px">
			<occurrence-form
			:chamadoEdit="null"
			:techList="technicianList"
			v-on:updateForm="showForm()"
			>
			</occurrence-form>
		</div>
		</div>

		<!--fim barra superior-->
	</section>
</template>

<script>
	import {mapGetters} from 'vuex';
	import ChatMensagem from "../mensagem/ChatMensagem";
	import TodasMenssagensChat from "../mensagem/TodasMenssagensChat";
	export default {
		components: {ChatMensagem, TodasMenssagensChat},
		data() {
			return {
				technicianList: [],
				toggleForm: false
			}
		},
		computed:{
			...mapGetters(
				[
					'getMessages',
					'getTotalChatQueue',
					'getTotalNaoLidoWhatsapp',
					'getTotalNaoLidoFacebook',
					'getTotalNaoLidoInstagram'
				]
			)
		},

		created(){
			axios.get("/dialer/userList").then(({data}) => {
            	data.forEach(element => {
                	this.technicianList.push({'value': element.id, 'text': element.name})
            	});
        	})
			this.toggleForm = false
		},

		methods: {
			showForm(){
				this.toggleForm = !this.toggleForm
			}
		}
	}
</script>

<style>
.alert-message-out{
	border-bottom: solid 1px red;
	border-left: solid 1px red;
	padding: 0 0 3px 3px;
}
.alert-message{
	border: solid 1px red;
	padding: 0 5px 0 5px;
	font-size: 13px;
}
.alert-message-in{
	border-bottom: solid 1px gray;
	border-left: solid 1px gray;
	padding: 0 0 3px 3px;
}
.alert-message-fine{
	border: solid 1px gray;
	padding: 0 5px 0 5px;
	font-size: 13px;
}
.icon-size {
	width: 18px;
	height: 18px;
}
</style>


<style scoped>
	#title {
		margin: auto;
	}

	#btnNovoChamado{
		margin-left: 5px;
	}

	.buttonOff {
        border: solid 2px #1c869a;
        border-radius: 15px;
        font-size: 14px;
        width: 170px;
        font-weight: 700;
        color: #1c869a;
        background-color: white;
        padding: 5px;
        margin: 5px;
        transition: 0.2s;
    }

    .buttonOff:hover {
        background-color: #358d9ec5;
        color: white
    }

    .buttonOn {
        border: solid 2px #1c869a;
        border-radius: 15px;
        font-size: 14px;
        width: 170px;
        font-weight: 700;
        color: white;
        background-color: #1c869a;;
        padding: 5px;
        margin: 5px;
    }

	.body {
		height: calc(100vh - 13em);
		display: flex;
		align-items: stretch;
	}
	.todasMensagens {
		width: 18em;
		overflow-y: auto;
		background: white;
		/* border-right: 1px solid gray; */
		border-right: solid 2px #1C869A;
		border-bottom: solid 2px #1C869A;
		border-radius: 0% 2% 2% 0%;

	}
	.chatMensagem {
		flex: 1;
	}
	@media screen and (max-width: 1489px) {
		.todasMensagens {
			width: 250px;
		}
	}
    @media screen and (max-width: 941px){
        .body{
            height: calc(100vh - 17.2em);
        }
    }
    /*
	@media screen and (max-height: 760px) {

        .body{
            height: calc(100vh - 18.5em);
            background-color: red;
        }
    }
    */
	.barra-superior{
		display: flex;
	}

</style>
